export default __webpack_public_path__ + "static/media/umass.d509e662.png";